

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const VERIFYOTP= createAsyncThunk(
  "verifyOTP/verifyOTP",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const verifyOTPSlice = createSlice({
  name: "verifyOTPSlice",
  initialState: {
    verifyOTP: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfverifyOTP: (state) => {
        state.verifyOTP.loading = false
        state.verifyOTP.error = false
        state.verifyOTP.data = []
        state.verifyOTP.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(VERIFYOTP.fulfilled, (state, action) => {
      state.verifyOTP = {
        ...state.verifyOTP,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(VERIFYOTP.pending, (state, action) => {
      state.verifyOTP = {
        ...state.verifyOTP,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(VERIFYOTP.rejected, (state, action) => {
      state.verifyOTP = {
        ...state.verifyOTP,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const verifyOTPAction = {
    VERIFYOTP,
};

export { verifyOTPAction };
export default verifyOTPSlice.reducer;
export const {setInitialStateOfverifyOTP} = verifyOTPSlice.actions
